import React from 'react';
import './style.less';

export default () => <span className="menu-item-divider"></span>;
